export const pt = {
    //------------ Login -----------
    loginTitle: 'Welcome',
    loginMessage: 'Enter your Login',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    newPassword: 'New Password',
    repeatNewPassword: 'Repeat New Password',
    authenticateUser: 'Authenticate User',
    recoverPassword: 'Recover Password',
    recoverPasswordDescription: 'Check your Email and Follow Instructions to Reset your Password',
    forgotPassword: 'Forgot Password',
    code: 'Code',
    acceptWordOs: 'Accept',
    acceptWordAs: 'Accept',
    termsConditions: 'Terms & Conditions',
    cookies: 'Cookies Policy',
    privacyRule: 'Accept',
    privacyRuleLink: 'Data Confidentiality',
    repeatPasswordLabel: 'Repeat the Password used above',
    inputLabelNewPassword: 'Password must Respect the Requirements',
    logout: 'Logout',
    'User Authenticated': 'User Authenticated',

    //------------ AuthContext Errors -----------
    incorrectFields: 'Incorrect Username or Password',
    passwordNoMatch: 'Passwords don´t match',
    passwordNotValid: 'Password doesn´t match the requirements',
    emailSentCode: 'Email sent with the verification code',
    codeSentByMessage: 'Code sent by message',
    firstLogin: 'First login, user needs to authenticate',
    errorResetPassword: 'Something went wrong, please check the code or password requirements',
    infoDescription: 'Can´t export when there are no data available',

    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',

    successAdd: 'Items added with success.',
    errorAdd: 'Error: item not added.',

    successDelete: 'Items deleted with success.',
    errorDelete: 'Error: item not deleted.',

    errorGettingCertificates: 'An error occurred getting certificate list.',
};